/** Pure decision for whether a post-trawl auto-score should fire. Extracted
 *  from curate.tsx so the gate is testable and shared across trawl/snowball/
 *  spot-trawl completion triggers. */
export interface AutoScoreInputs {
  unscoredCount: number;
  hasDescription: boolean;
  scoringRunning: boolean;
  atScoringLimit: boolean;
}

export function shouldAutoScore(i: AutoScoreInputs): boolean {
  return (
    i.unscoredCount > 0 &&
    i.hasDescription &&
    !i.scoringRunning &&
    !i.atScoringLimit
  );
}
